<div class="similar-banner" [class.mobile]="topService.isMobile">
    <div class="similar-banner-content">
        <div class="similar-banner-content__image" *ngIf="topService.isMobile">
            <img src="assets/images/similar-items/similar-items-banner-mobile.png" width="320" alt="Similar Items Banner">
        </div>
        <div class="similar-banner-content__text">
            <h3>Now Showing Multiple Options per SKU</h3>
            <p>Compare by price, availability, and shipping times — all in one place.</p>
        </div>
    </div>
</div>